module.exports = __webpack_public_path__ + "static/projekte-felix-mottl-strasse-16-1-17da94c4dcaf6f0e1349b5d95eecdc6e.jpg";